import React from 'react';
import {action, makeObservable, observable} from 'mobx';
import {observer} from 'mobx-react';
import {TimeSpan} from '@sparkware/app-utils';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {JackpotWidgetClockBox} from './boxes/footer/clock/box/jackpot-widget-clock.box';
import {JackpotType} from '../../services/jackpots/jackpot.constants';
import {JACKPOT_WIDGET_LAYOUT} from './jackpot-widget.component';
import {SetIntervalType} from "../../../common/types/set-interval-type";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import {NullableJackpotViewModel} from "../../services/jackpots/models/jackpot.view-model.interface";

interface IDailyJackpotWidgetClockComponentProps extends ComponentServicesPick<'jackpots'>{
    jackpot: NullableJackpotViewModel;
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth?: number;
    jackpotType: JackpotType;
}


@observer
class ComponentBody extends OrbitComponent<IDailyJackpotWidgetClockComponentProps> {
    private updateClockInterval: SetIntervalType;

    @observable.ref
    private clockValue: string = "";

    constructor(props: IDailyJackpotWidgetClockComponentProps) {
        super(props);

        makeObservable(this);
    }

    componentDidMount() {
        this.clockInit();
    }

    componentDidUpdate(prevProps: IDailyJackpotWidgetClockComponentProps) {
        const previousMustHitTime = prevProps.jackpot?.mustHitTime;
        const currentMustHitTime = this.props.jackpot?.mustHitTime
        if (previousMustHitTime && currentMustHitTime && previousMustHitTime.getTime() !== currentMustHitTime.getTime()) {
            this.clearClockInterval();
            this.clockInit();
        }
    }

    componentWillUnmount() {
        this.clearClockInterval();
    }

    private clockInit() {
        this.updateClock();
        this.updateClockInterval = setInterval(() => {
            this.updateClock();
        }, 1000);
    }

    private clearClockInterval() {
        if (this.updateClockInterval) {
            clearInterval(this.updateClockInterval);
            this.updateClockInterval = undefined;
        }
    }

    @action.bound
    private updateClock() {
        const serverDate = this.services.time.getCurrentServerDate();
        if (!serverDate) {
            this.services.logger.warning('Server date is invalid');
            return;
        }

        const mustHitDate = this.props.jackpot?.mustHitTime;

        if(!mustHitDate) {
            return;
        }

        // round it to 1 second
        const remainingTimeMilis = Math.round((mustHitDate.getTime() - serverDate.getTime()) / 1000) * 1000;
        const remainingTimeTimeSp = TimeSpan.fromMilliseconds(Math.max(0, remainingTimeMilis));
        this.clockValue = remainingTimeTimeSp.toString({useTotalHours: true});
    }

    render() {
        return <JackpotWidgetClockBox
            className="cy-daily-jackpot-clock"
            layout={this.props.layout}
            widgetWidth={this.props.widgetWidth}
            themeType={this.props.jackpots.getThemeType(this.props.jackpotType)}
            isDaily={this.props.jackpotType === JackpotType.Daily}
        >
            {this.clockValue}
        </JackpotWidgetClockBox>;
    }
}

export const JackpotWidgetClockComponent = withServices(ComponentBody, ['jackpots']);